// 运营中心首页api
import request from '@/util/request'

//查询全部标签
export function getLabels(params){
	return request({
		url:`/user-s/tag/list`,
		params
	})
}
//数据驾驶舱--电站数量统计
export function getCockpitStationStatistics(params){
	return request({
		url:`/maintain-s/operating/station/count/summary`,
		method: 'get',
		params
	})
}
//数据驾驶舱--装机容量统计
export function getCockpitInstalledcapacitystatistics(params){
	return request({
		url:`/maintain-s/operating/station/capacity/summary`,
		method: 'get',
		params
	})
}
//电站运营状态统计加和
export function getStationStatistic(data) {
    return request({
        // url: `/maintain_old/operation/station/statistic`,
        url: `/maintain-s/operating/station/status/counting`,
		method: 'post',
	    data
    });
}

// 当月日均满发小时数
export function getMonthHoursList(params,data) {
    return request({
        url: `/maintain-s/history/power/rank`,
		method: 'post',
        params,
        data
    });
}
// 整体发电历史--月
export function getGenerationMonthDayData(params,data) {
    return request({
        url: `/maintain-s/history/power/stats/month`,
        method: 'post',
        params,
		data
    });
}

// 整体发电历史
export function getGenerationYearMonthData(params,data) {
    return request({
        url: `/maintain-s/history/power/stats/year`,
		method: 'post',
        params,
        data
    });
}

// 首页-整体计划发电量--年
export function getMonthGenerationPlanData(year,data) {
    return request({
        url: `/maintain-s/history/power/generation-plan/year?year=${year}`,
        method: 'post',
        data
    });
}
//获取单体电站计划发电--年
export function getSingleMonthGenerationPlanData(id,year) {
    return request({
        url: `/maintain-s/history/power/${id}/generation-plan/year?year=${year}`,
        method: 'get',
    });
}
//首页 整体计划发电量--总
export function getYearGenerationPlanData(data) {
    return request({
        url: `/maintain-s/history/power/generation-plan/total`,
        method: 'post',
        data
    });
}
//获取单体电站计划发电--总
export function getSingleYearGenerationPlanData(id) {
    return request({
        url: `/maintain-s/history/power/${id}/generation-plan/total`,
        method: 'get'
    });
}
//整体发电概况
export function getGenerationSummary(data){
    return request({
        url: `/maintain-s/operating/station/generation/summary`,
        method: 'post',
        data
    })
}
//当日报警概况
export function alertSummary(data) {
	return request({
		url: `/maintain-s/operating/station/alert/summary`,
		method: 'post',
		data
	})
}
// 功率归一化
export function getNormalizedList(datas,data) {
    return request({
        url: `/maintain-s/operating/station/capacity/ranking?order=${datas}`,
    method: 'post',
    data
    });
}


// WEBPACK FOOTER //
// ./src/api/maintain/home.js